import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type CreateProposalInput = {
  accountName: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  attendees: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  hotelId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  segmentationType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};

/** A decoration object represents the model of a decoration that can be placed eather in a virtual space or in a furniture. */
export type Decoration = VirtualObject & {
  __typename?: 'Decoration';
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

/** A composition represents a set of virtual objects in a user defined pattern. */
export type FComposition = {
  __typename?: 'FComposition';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  schema: Scalars['JSON']['output'];
  type: FCompositionType;
};

/** A composition represents a set of virtual objects in a user defined pattern. */
export enum FCompositionType {
  Arrangement = 'Arrangement',
  Ensemble = 'Ensemble'
}

/** A furniture object represents the model of a furniture that can be placed in a virtual space. */
export type Furniture = VirtualObject & {
  __typename?: 'Furniture';
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new graph. */
  createGraph: ShallowGraph;
  /** Create a new proposal. */
  createProposal: Proposal;
  /** Update an existing graph. */
  updateGraph: ShallowGraph;
};


export type MutationCreateGraphArgs = {
  graph: ShallowGraphInput;
};


export type MutationCreateProposalArgs = {
  graph: ShallowGraphInput;
  input: CreateProposalInput;
};


export type MutationUpdateGraphArgs = {
  graph: ShallowGraphInput;
  id: Scalars['ID']['input'];
};

export type PaginatedResponse = {
  __typename?: 'PaginatedResponse';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  accountName: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  attendees: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  endDate: Scalars['Date']['output'];
  graph: ShallowGraph;
  hotelId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  segmentationType: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get a composition by its ID (nid). */
  fcomposition: FComposition;
  /** Get compositions by type. */
  fcompositions: Array<FComposition>;
  /** Get Schemas filtered by type */
  schemas: Array<Scalars['JSON']['output']>;
  /** Get a template by its ID. */
  templates: Array<Template>;
  /** Get a virtual object by its ID (nid). */
  virtualObject: VirtualObject;
  /** Get virtual objects by space ID and type. */
  virtualObjects: VirtualObjectsResponse;
  /** Get a virtual space by its ID (nid). */
  virtualSpace: VirtualSpace;
};


export type QueryFcompositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFcompositionsArgs = {
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<FCompositionType>;
};


export type QuerySchemasArgs = {
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplatesArgs = {
  filters?: InputMaybe<TemplatesFiltersInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['ID']['input'];
};


export type QueryVirtualObjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVirtualObjectsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<VirtualObjectType>;
};


export type QueryVirtualSpaceArgs = {
  id: Scalars['ID']['input'];
};

/** Schema types */
export enum SchemaType {
  BoardroomArrangement = 'boardroom_arrangement',
  /** FArrangement types */
  TheaterArrangement = 'theater_arrangement'
}

export type ShallowGraph = {
  __typename?: 'ShallowGraph';
  cursor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nodes: Scalars['JSON']['output'];
  space: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type ShallowGraphInput = {
  cursor: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nodes: Scalars['JSON']['input'];
  space: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type Template = {
  __typename?: 'Template';
  description: Scalars['String']['output'];
  graph: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TemplatesFiltersInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A virtual object represents the model of a furniture or decoration. */
export type VirtualObject = {
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

/** The type of a virtual object. */
export enum VirtualObjectType {
  /** A decoration object. */
  Decoration = 'Decoration',
  /** A furniture object. */
  Furniture = 'Furniture'
}

export type VirtualObjectsResponse = {
  __typename?: 'VirtualObjectsResponse';
  data: Array<VirtualObject>;
  pagination: PaginatedResponse;
};

/** A virtual space represents a 3D model of a room or a space that can be decorated with virtual objects. */
export type VirtualSpace = {
  __typename?: 'VirtualSpace';
  hotel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid?: Maybe<Scalars['Int']['output']>;
  placeholder: Scalars['String']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  VirtualObject: ( Decoration ) | ( Furniture );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CreateProposalInput: CreateProposalInput;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  Decoration: ResolverTypeWrapper<Decoration>;
  FComposition: ResolverTypeWrapper<FComposition>;
  FCompositionType: FCompositionType;
  Furniture: ResolverTypeWrapper<Furniture>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  Mutation: ResolverTypeWrapper<{}>;
  PaginatedResponse: ResolverTypeWrapper<PaginatedResponse>;
  Proposal: ResolverTypeWrapper<Proposal>;
  Query: ResolverTypeWrapper<{}>;
  SchemaType: SchemaType;
  ShallowGraph: ResolverTypeWrapper<ShallowGraph>;
  ShallowGraphInput: ShallowGraphInput;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Template: ResolverTypeWrapper<Template>;
  TemplatesFiltersInput: TemplatesFiltersInput;
  VirtualObject: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['VirtualObject']>;
  VirtualObjectType: VirtualObjectType;
  VirtualObjectsResponse: ResolverTypeWrapper<Omit<VirtualObjectsResponse, 'data'> & { data: Array<ResolversTypes['VirtualObject']> }>;
  VirtualSpace: ResolverTypeWrapper<VirtualSpace>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean']['output'];
  CreateProposalInput: CreateProposalInput;
  Date: Scalars['Date']['output'];
  Decoration: Decoration;
  FComposition: FComposition;
  Furniture: Furniture;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  Mutation: {};
  PaginatedResponse: PaginatedResponse;
  Proposal: Proposal;
  Query: {};
  ShallowGraph: ShallowGraph;
  ShallowGraphInput: ShallowGraphInput;
  String: Scalars['String']['output'];
  Template: Template;
  TemplatesFiltersInput: TemplatesFiltersInput;
  VirtualObject: ResolversInterfaceTypes<ResolversParentTypes>['VirtualObject'];
  VirtualObjectsResponse: Omit<VirtualObjectsResponse, 'data'> & { data: Array<ResolversParentTypes['VirtualObject']> };
  VirtualSpace: VirtualSpace;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DecorationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Decoration'] = ResolversParentTypes['Decoration']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VirtualObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FCompositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FComposition'] = ResolversParentTypes['FComposition']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  schema?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FCompositionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FurnitureResolvers<ContextType = any, ParentType extends ResolversParentTypes['Furniture'] = ResolversParentTypes['Furniture']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VirtualObjectType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createGraph?: Resolver<ResolversTypes['ShallowGraph'], ParentType, ContextType, RequireFields<MutationCreateGraphArgs, 'graph'>>;
  createProposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType, RequireFields<MutationCreateProposalArgs, 'graph' | 'input'>>;
  updateGraph?: Resolver<ResolversTypes['ShallowGraph'], ParentType, ContextType, RequireFields<MutationUpdateGraphArgs, 'graph' | 'id'>>;
};

export type PaginatedResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaginatedResponse'] = ResolversParentTypes['PaginatedResponse']> = {
  hasNext?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProposalResolvers<ContextType = any, ParentType extends ResolversParentTypes['Proposal'] = ResolversParentTypes['Proposal']> = {
  accountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attendees?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  graph?: Resolver<ResolversTypes['ShallowGraph'], ParentType, ContextType>;
  hotelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  segmentationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  fcomposition?: Resolver<ResolversTypes['FComposition'], ParentType, ContextType, RequireFields<QueryFcompositionArgs, 'id'>>;
  fcompositions?: Resolver<Array<ResolversTypes['FComposition']>, ParentType, ContextType, RequireFields<QueryFcompositionsArgs, 'spaceId'>>;
  schemas?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QuerySchemasArgs, 'spaceId'>>;
  templates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType, RequireFields<QueryTemplatesArgs, 'spaceId'>>;
  virtualObject?: Resolver<ResolversTypes['VirtualObject'], ParentType, ContextType, RequireFields<QueryVirtualObjectArgs, 'id'>>;
  virtualObjects?: Resolver<ResolversTypes['VirtualObjectsResponse'], ParentType, ContextType, RequireFields<QueryVirtualObjectsArgs, 'spaceId'>>;
  virtualSpace?: Resolver<ResolversTypes['VirtualSpace'], ParentType, ContextType, RequireFields<QueryVirtualSpaceArgs, 'id'>>;
};

export type ShallowGraphResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShallowGraph'] = ResolversParentTypes['ShallowGraph']> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodes?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  space?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  graph?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualObject'] = ResolversParentTypes['VirtualObject']> = {
  __resolveType: TypeResolveFn<'Decoration' | 'Furniture', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['VirtualObjectType'], ParentType, ContextType>;
};

export type VirtualObjectsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualObjectsResponse'] = ResolversParentTypes['VirtualObjectsResponse']> = {
  data?: Resolver<Array<ResolversTypes['VirtualObject']>, ParentType, ContextType>;
  pagination?: Resolver<ResolversTypes['PaginatedResponse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VirtualSpaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['VirtualSpace'] = ResolversParentTypes['VirtualSpace']> = {
  hotel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Date?: GraphQLScalarType;
  Decoration?: DecorationResolvers<ContextType>;
  FComposition?: FCompositionResolvers<ContextType>;
  Furniture?: FurnitureResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  PaginatedResponse?: PaginatedResponseResolvers<ContextType>;
  Proposal?: ProposalResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ShallowGraph?: ShallowGraphResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  VirtualObject?: VirtualObjectResolvers<ContextType>;
  VirtualObjectsResponse?: VirtualObjectsResponseResolvers<ContextType>;
  VirtualSpace?: VirtualSpaceResolvers<ContextType>;
};

